import { action, makeObservable } from "mobx";
import {
  BusinessLocationTssDto,
  ChangeAdminPinDto,
  ClientInfoDto,
  TaxationApi,
  TssInfoDto,
  UpdateTssDto,
} from "../../api-client";
import AuthStore from "../Auth/authStore";
import { BaseStore } from "../BaseStore";

export default class TaxationStore extends BaseStore<TaxationApi> {
  public authStore: AuthStore;

  public constructor(api: TaxationApi, authStore: AuthStore) {
    super(api);
    this.authStore = authStore;
    makeObservable(this, {
      createTSS: action,
    });
  }

  public createTSS = async (
    businessLocationTssDto: BusinessLocationTssDto
  ): Promise<TssInfoDto> => {
    const { data } = await this.apiUnwrapped.createTss(businessLocationTssDto);
    return data;
  };

  public updateTss = async (
    updateTssDto: UpdateTssDto
  ): Promise<TssInfoDto> => {
    const { data } = await this.apiUnwrapped.updateTss(updateTssDto);
    return data;
  };

  public changeAdminPin = async (
    tssId: string,
    newPin: ChangeAdminPinDto
  ): Promise<any> => {
    const { data } = await this.apiUnwrapped.changeAdminPin(tssId, newPin);
    return data;
  };

  public authenticateAdmin = async (tssId: string): Promise<any> => {
    const { data } = await this.apiUnwrapped.authenticateAdmin(tssId);
    return data;
  };

  public logoutAdmin = async (tssId: string): Promise<any> => {
    const { data } = await this.apiUnwrapped.logOutAdmin(tssId);
    return data;
  };

  public createClient = async (tssId: string): Promise<ClientInfoDto> => {
    const { data } = await this.apiUnwrapped.createClientTSS(tssId);
    return data;
  };

  public getDashboardStats = async (): Promise<{
    totalTss: number;
    totalClients: number;
    totalExports: number;
  }> => {
    const { data } = await this.apiUnwrapped.getDashboardStats();
    return {
      totalTss: data.totalTss ?? 0,
      totalClients: data.totalClients ?? 0,
      totalExports: data.totalExports ?? 0,
    };
  };
}
